import { gql } from "@/__generated__/gql";

export const CURRENT_USER_PERMISSIONS = gql(`
  query CurrentUserPermissions($organizationId: ID!) {
    me {
      id
      uuid
      isDefaultCounselor(organizationId: $organizationId)
      isSuperCounselor(organizationId: $organizationId)
    }
  }
`);
